require('./_bootstrap');
require('cookieconsent');
require('./_navbar');

/**
 * Here goes scripts, that will be executed on every page.
 * Scripts, that needs to bu run on particular pages should be
 * placed in route folders above this file.
 */

$.extend(DataTable.ext.classes, {
  sPageButton: 'btn btn-primary ml-5'
});

if (language === 'es_ES') {
  $.extend($.fn.dataTable.defaults, {
    language: require('../_lib/data-tables/lang/es_ES.json')
  });
}

if (language === 'fr_FR') {
  $.extend($.fn.dataTable.defaults, {
    language: require('../_lib/data-tables/lang/fr_FR.json')
  });
}

$(() => {
  $('#lnswitcher').lnswitcher({
    onSelect: (selected) => {
      window.location.href = setCountryUrl + selected;
    }
  });

  $('#lnswitcher_lang').lnswitcher({
    onSelect: (selected) => {
      window.location.href = setLanguageUrl + selected;
    }
  });

  ;

  window.addEventListener('load', () => {
    const cookieLangs = ['en_Europe', 'en_GB', 'en_IE', 'es_ES', 'fr_FR'];
    let enabled = false;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const pageLanguage = $('#lnswitcher').find('.value').html();
    const userCookieAccepted = '<?php echo $this->layout()->cookieAccepted ?>' === '1';

    if (!userCookieAccepted) {
      if (cookieLangs.indexOf(pageLanguage) !== -1) {
        enabled = true;
      } else if (timezone.indexOf('Europe') !== -1) {
        enabled = true;
      }
    }

    window.cookieconsent.initialise({
      enabled,
      content: {
        header: __('Cookies used on the website!'),
        message: __('This website uses cookies to ensure you get the best experience on our website.'),
        dismiss: __('Got it!'),
        allow: __('Allow cookies'),
        deny: __('Decline'),
        link: __('Learn more'),
        policy: __('Cookie Policy')
      },
      palette: {
        popup: {
          background: 'var(--bg-cookieconsent)'
        }
      },
      elements: {
        dismiss: '<a aria-label="dismiss cookie message" role="button" tabindex="0" class="cc-btn cc-dismiss btn btn-primary">Got it!</a>'
      },
      theme: 'classic',
      onStatusChange() {
        if (this.hasConsented()) {
          $.get('/accept-cookies', null, (e) => {
            console.log(e);
          });
        }
      }
    });
  });
});

$(() => {
  const oldXHR = window.XMLHttpRequest;

  function newXHR() {
    const realXHR = new oldXHR();

    realXHR.addEventListener('readystatechange', (data) => {
      if (data.target.readyState == 4) {
        try {
          const jsonObject = JSON.parse(data.target.response);

          if (typeof jsonObject.redirectToUrl != 'undefined') {
            window.location.href = jsonObject.redirectToUrl;

            return false;
          }
        } catch(err) {}
      }
    }, false);

    return realXHR;
  }

  $('body').tooltip({
    selector: '.btooltip[title]'
  });

  const taizeBaner = $('.taize-banner');
  const taizeBannerHidden = localStorage.getItem('taize-banner-hidden');

  if (!taizeBannerHidden) {
    taizeBaner.addClass('in');
  }

  taizeBaner.find('button').click(() => {
    localStorage.setItem('taize-banner-hidden', true);
  });

  const audioRecordingBanner = $('.audio-recording-banner');
  const audioRecordingBannerHidden = localStorage.getItem('audio-recording-banner-hidden');

  if (!audioRecordingBannerHidden) {
    audioRecordingBanner.addClass('in');
  }

  audioRecordingBanner.find('button').click(() => {
    localStorage.setItem('audio-recording-banner-hidden', true);
  });

  window.XMLHttpRequest = newXHR;
});
